
export const fetch_with_auth = async (url, accessToken, refreshToken, options = {}) => {

    if (!accessToken) {
        return [false, {}];
    }

    const response = await fetch(url, {
        method: options.method,
        ...options.others,
        headers: {
            ...options.headers,
            'Authorization': `Bearer ${accessToken}`
        }
    });

    if (response.status === 401) {
        const refreshResponse = await fetch('/api/user/token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: refreshToken }),
        });

        if (refreshResponse.status === 200) {
            const { accessToken: newAccessToken } = await refreshResponse.json();
            
            // Retry the original request with the new access token
            const retryResponse = await fetch(url, {
                method: options.method,
                ...options.others,
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${newAccessToken}`
                }
            });
            if (retryResponse.status === 200) {
                return [
                    true,
                    {
                        response: retryResponse
                    }
                ]
            } else {
                return [false, {}]
            }
        } else {
            return [false, {}]
        }
    } else {
        return [
            true,
            {
                response: response
            }
        ]
    }
}

